<script>
  import options from './PriceToggle.options'
  export default options
</script>

<template>
  <button v-if="showPriceToggle" @click="toggle" class="nlx-price-toggle" :class="{'nlx-price-toggle--active':toggled}">
    <span>{{getLabel('msrp_price_toggle')}}</span>
    <div class="nlx-price-toggle__toggle">
      <div class="nlx-price-toggle__toggle-blip"></div>
    </div>
  </button>
</template>
